import { axiosPublic } from '../../services/api/api'

import { CollectionRecord } from './../../types/collectionData'
import { headers } from './util'

export const getCollectionData = () =>
    axiosPublic.get<CollectionRecord[]>('collections', {
        headers,
    })

export const getRecordYears = (
    controller: AbortController,
    recordType: string,
    key: string
) =>
    axiosPublic.get<string[]>(`${recordType}/${key}/years`, {
        signal: controller.signal,
    })
